// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  all: unset;
}
.menu-container {
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin-bottom: 10px;
  background-color: #1d1d1d;
  border-radius: 20px;
  animation: showMenu 0.1s ease;
  position: relative;
  z-index: 2;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  color: #a8a8a8;
}

.menu-items {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.menu-item {
  display: flex;
  gap: 8px;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: space-between;
  background-color: #292929;
  padding: 12px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1em;
  outline: 1px solid #333333;
  color: #a8a8a8;
}

.menu-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #292929;
  border-radius: 8px;
  outline: 1px solid #333333;
  color: #a8a8a8;
  font-size: 16px;
}

.change-name-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.change-name-description {
  margin-bottom: 20px;
  text-align: center;
}

.name-input {
  border-radius: 8px;
  background-color: #0f0f0f;
  width: 70%;
  padding: 8px 12px;
  text-align: center;
  box-sizing: border-box;
}

.statistics-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.statistics-item-container {
  display: flex;
  width: 100%;
  background-color: slateblue;
  padding: 5px 10px;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
}
.statistics-item {
  opacity: 0.9;
}

@keyframes showMenu {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

.friends-list {
  gap: 5px;
  display: flex;
  flex-direction: column;
  max-height: 25vh;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  border-radius: 12px;
}

.requests-section {
  padding-top: 2em;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Menu.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["input {\r\n  all: unset;\r\n}\r\n.menu-container {\r\n  justify-content: space-between;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  margin-bottom: 10px;\r\n  background-color: #1d1d1d;\r\n  border-radius: 20px;\r\n  animation: showMenu 0.1s ease;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.menu-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 40px;\r\n  color: #a8a8a8;\r\n}\r\n\r\n.menu-items {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 8px;\r\n}\r\n\r\n.menu-item {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #292929;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  line-height: 1em;\r\n  outline: 1px solid #333333;\r\n  color: #a8a8a8;\r\n}\r\n\r\n.menu-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #292929;\r\n  border-radius: 8px;\r\n  outline: 1px solid #333333;\r\n  color: #a8a8a8;\r\n  font-size: 16px;\r\n}\r\n\r\n.change-name-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.change-name-description {\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.name-input {\r\n  border-radius: 8px;\r\n  background-color: #0f0f0f;\r\n  width: 70%;\r\n  padding: 8px 12px;\r\n  text-align: center;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.statistics-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.statistics-item-container {\r\n  display: flex;\r\n  width: 100%;\r\n  background-color: slateblue;\r\n  padding: 5px 10px;\r\n  border-radius: 8px;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.statistics-item {\r\n  opacity: 0.9;\r\n}\r\n\r\n@keyframes showMenu {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-50px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n.friends-list {\r\n  gap: 5px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 25vh;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow-y: scroll;\r\n  border-radius: 12px;\r\n}\r\n\r\n.requests-section {\r\n  padding-top: 2em;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
